import {Component, Input, OnDestroy, OnInit} from "@angular/core";

@Component({
  selector: 'dx-route-not-found',
  templateUrl: './dx-route-not-found-report.component.html',
  styleUrls: ['./dx-route-not-found-report.component.css']
})
export class DxRouteNotFoundReportComponent implements OnInit, OnDestroy {
  @Input()
  public message: string;

  constructor() {}

  ngOnInit(): void { }
  ngOnDestroy(): void { }

  public onSendErrorReport(): void {
    alert('Функциональность не реализована!');
  }
}
